/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import {
  SECURE_ENDPOINT,
  UNSECURE_ENDPOINT
} from "@/core/AppConfiguration";

import {
  SECURE_ENDPOINT as OTHER_SECURE_ENDPOINT
} from "@/app/core/ApiConfiguration";

export default class ServicePath {

  /**
   * * LOGIN SERVICE
   */
  static VALIDATE_USER = SECURE_ENDPOINT + 'lsvc/lu02';
  static LOGIN_USER = SECURE_ENDPOINT + 'lsvc/ls01';

  /**
   * * PREFERENCES SERVICE 
   */
  static SAVE_PREFERENCES = SECURE_ENDPOINT + 'uspfrvc/uspfr01'

  /**
   * * PATIENT SERVICE
   */
  static PATIENT_ADD = SECURE_ENDPOINT + 'patvc/pat01';
  static PATIENT_LIST_ALL = SECURE_ENDPOINT + 'patvc/pat02';
  static PATIENT_UPDATE = SECURE_ENDPOINT + 'patvc/pat03';
  static PATIENT_DELETE = SECURE_ENDPOINT + 'patvc/pat04';
  static PATIENT_LIST_BY_ID = SECURE_ENDPOINT + 'patvc/pat05'
  static PATIENT_FIND_HISTORICAL_CLINIC = SECURE_ENDPOINT + 'patvc/pat07'
  static PATIENT_PERSONAL_INFO = SECURE_ENDPOINT + 'patvc/pat08'
  static PATIENT_LIST_ALL_PENDING = SECURE_ENDPOINT + 'patvc/pat09'
  static PATIENT_VALID_CURP = SECURE_ENDPOINT + 'patvc/pat10';
  static PATIENT_ADD_SCANNER_DOCUMENT = SECURE_ENDPOINT + 'patvc/pat11';
  static PATIENT_LIST_ALL_BY_BRANCH_OFFICE = SECURE_ENDPOINT + 'patvc/pat12';
  static PATIENT_LIST_ALL_BY_DATE = SECURE_ENDPOINT + 'patvc/pat13';
  static PATIENT_LIST_RECEPTION_PAGINATION = SECURE_ENDPOINT + 'patvc/pat14';

  /**
   * * APPOINTMENT SERVICE 
   */
  static APPOINTMENT_ADD = SECURE_ENDPOINT + 'appovc/appo01';
  static APPOINTMENT_LIST_ALL = SECURE_ENDPOINT + 'appovc/appo02';
  static APPOINTMENT_UPDATE = SECURE_ENDPOINT + 'appovc/appo03';
  static APPOINTMENT_DELETE = SECURE_ENDPOINT + 'appovc/appo04';
  static APPOINTMENT_LIST_BY_ID = SECURE_ENDPOINT + 'appovc/appo05';
  static APPOINTMENT_LIST_BY_CONSULTING_ROOM = SECURE_ENDPOINT + 'appovc/appo06';
  static APPOINTMENT_NOTIFICATION = SECURE_ENDPOINT + 'appovc/appo11';
  static APPOINTMENT_ALL_BY_BRANCH_AND_RANGE = SECURE_ENDPOINT + 'appovc/appo12';
  static APPOINTMENT_ALL_PENDING = SECURE_ENDPOINT + 'appovc/apo13';
  static APPOINTMENT_UPDATE_STATUS = SECURE_ENDPOINT + 'appovc/apo14';
  static APPOINTMENT_LIST_ALL_BY_SPECIALITY = SECURE_ENDPOINT + 'appovc/apo15';
  static APPOINTMENT_CANCEL_FROM_SOMATOMETRY = SECURE_ENDPOINT + 'appovc/apo17';

  /**
   * * CANCELATION APPOINTMENT SERVICE
   */
  static CANCELLATION_APPOINTMENT_ADD = SECURE_ENDPOINT + 'canappovc/canappo01'
  static CANCELLATION_APPOINTMENT_LIST_ALL = SECURE_ENDPOINT + 'canappovc/canappo02'
  static CANCELLATION_APPOINTMENT_UPDATE = SECURE_ENDPOINT + 'canappovc/canappo03'
  static CANCELLATION_APPOINTMENT_DELETE = SECURE_ENDPOINT + 'canappovc/canappo04'

  /**
   * * REPROGRAMMED APPOINTMENT SERVICE
   */
  static REPROGRAMMED_APPOINTMENT_ADD = SECURE_ENDPOINT + 'reappovc/reappo01'
  static REPROGRAMMED_APPOINTMENT_LIST_ALL = SECURE_ENDPOINT + 'reappovc/reappo02'
  static REPROGRAMMED_APPOINTMENT_UPDATE = SECURE_ENDPOINT + 'reappovc/reappo03'
  static REPROGRAMMED_APPOINTMENT_DELETE = SECURE_ENDPOINT + 'reappovc/reappo04'

  /**
   * * STUDY SERVICE
   */
  static STUDY_ADD = SECURE_ENDPOINT + 'appovc/apo18';
  static STUDY_LIST_ALL = SECURE_ENDPOINT + 'stuvc/stu02';
  static STUDY_UPDATE = SECURE_ENDPOINT + 'stuvc/stu03';
  static STUDY_DELETE = SECURE_ENDPOINT + 'stuvc/stu04';
  static STUDY_BEGIN = SECURE_ENDPOINT + 'stuvc/stu06';
  static STUDY_READY = SECURE_ENDPOINT + 'stuvc/stu07';
  static STUDY_RESCHEDULE = SECURE_ENDPOINT + 'stuvc/stu08';
  static STUDY_CANCEL = SECURE_ENDPOINT + 'stuvc/stu09';
  static STUDY_LIST_ALL_BY_ESTATUS = SECURE_ENDPOINT + 'stuvc/stu10';
  static STUDY_BY_ID = SECURE_ENDPOINT + 'stuvc/stu11';
  static STUDY_LIST_ALL_PENDING = SECURE_ENDPOINT + 'stuvc/stu12';
  static STUDY_LIST_HISTORY = SECURE_ENDPOINT + 'stuvc/stu13';
  static STUDY_ADD_LIST_STUDIES = SECURE_ENDPOINT + 'stuvc/stu14';
  static STUDY_CHANGE_STATUS = SECURE_ENDPOINT + 'stuvc/stu15';
  static STUDY_CHANGE_STATUS_REPORTER = SECURE_ENDPOINT + 'stuvc/stu16';
  static STUDY_CHANGE_STATUS_DISCARD = SECURE_ENDPOINT + 'stuvc/stu17';
  static STUDY_VALIDATE_PACS = SECURE_ENDPOINT + 'stuvc/stu18';
  static STUDY_FIND_ALL_IMAGES_BY_STUDY = SECURE_ENDPOINT + 'stuvc/stu19';
  // static STUDY_FIND_URL_JNLP = SECURE_ENDPOINT + 'stuvc/stu20';
  static STUDY_HISTORY_BRANCH_OFFICE = SECURE_ENDPOINT + 'stuvc/stu21';
  static STUDY_INTERPRETATION_PENDING_VALIDATE_PACS = SECURE_ENDPOINT + 'stuvc/stu24';
  static STUDY_REVALIDATE = SECURE_ENDPOINT + 'stuvc/stu28';
  static STUDY_LINK_TO_SHARE_WA = SECURE_ENDPOINT + "stuvc/stu29";
  static STUDY_LINK_TO_VIEW_IMAGES = SECURE_ENDPOINT + "stuvc/stu30";
  static STUDY_DOWNLOAD_DICOMS = UNSECURE_ENDPOINT + "stuvc/dw06/";
  static STUDIES_BY_PATIENT = SECURE_ENDPOINT + "stuvc/stu31";

  static STUDY_BACKGROUND_CURRENT = SECURE_ENDPOINT + "stuvc/stubg01";
  static STUDY_BACKGROUND_BY_STUDY = `${SECURE_ENDPOINT}stuvc/stubg02`;


  /**
   * * ENUM SERVICE
   */
  static PERSON_LIST_STATUS = SECURE_ENDPOINT + 'enumvc/enum01';
  static MARITAL_LIST_STATUS = SECURE_ENDPOINT + 'enumvc/enum02';
  static FAMILIAR_LIST_TYPE = SECURE_ENDPOINT + 'enumvc/enum03';
  static ANTECEDENT_LIST_PERSON = SECURE_ENDPOINT + 'enumvc/enum04';
  static CLINICAL_LIST_EVENT_STATUS = SECURE_ENDPOINT + 'enumvc/enum05';
  static CLINICAL_LIST_EVENT_TYPE = SECURE_ENDPOINT + 'enumvc/enum06';
  static APPOINTMENT_LIST_STATUS = SECURE_ENDPOINT + 'enumvc/enum07';
  static APPOINTMENT_LIST_TYPE = SECURE_ENDPOINT + 'enumvc/enum08';
  static MEDICAL_PRACTICE_LIST_STATUS = SECURE_ENDPOINT + 'enumvc/enum09';
  static STUDY_LIST_STATUS = SECURE_ENDPOINT + 'enumvc/enum10';
  static STUDY_FINISHED_LIST_TYPE = SECURE_ENDPOINT + 'enumvc/enum11';
  static INTERPRETATION_LIST_TYPE = SECURE_ENDPOINT + 'enumvc/enum12';
  static INTERPRETATION_LIST_STATUS = SECURE_ENDPOINT + 'enumvc/enum13';
  static TEMPLATE_INTERPRETATION_LIST_TYPE = SECURE_ENDPOINT + 'enumvc/enum14';
  static TEMPLATE_INTERPRETATION_LIST_STATUS = SECURE_ENDPOINT + 'enumvc/enum15';
  static SIGN_LIST_STATUS = SECURE_ENDPOINT + 'enumvc/enum16';
  static ADDENDUM_LIST_STATUS = SECURE_ENDPOINT + 'enumvc/enum17';
  static MODALTY_LIST_SPECIALITY = SECURE_ENDPOINT + 'enumvc/enum18';
  static STUDY_LIST_PRIORITY = SECURE_ENDPOINT + 'enumvc/enum19';
  static BRANCH_OFFICE_DAY = SECURE_ENDPOINT + 'enumvc/enum20';
  static BRANCH_OFFICE_TURN = SECURE_ENDPOINT + 'enumvc/enum21';
  static ORDER_LOGOS = SECURE_ENDPOINT + 'enumvc/enum22';
  static CONTAINER_TYPE = SECURE_ENDPOINT + 'enumvc/enum23';
  static DISABILITY_GET = SECURE_ENDPOINT + 'enumvc/enum24';

  /**
   * * CATALOGUE SERVICE 
   */
  static CATALOGUE_ADD = SECURE_ENDPOINT + 'catavc/cata01';
  static CATALOGUE_LIST_ALL = SECURE_ENDPOINT + 'catavc/cata02';
  static CATALOGUE_UPDATE = SECURE_ENDPOINT + 'catavc/cata03';
  static CATALOGUE_DELETE = SECURE_ENDPOINT + 'catavc/cata04';

  /**
   * * CATEGORY SERVICE 
   */
  static CATEGORY_ADD = SECURE_ENDPOINT + 'catevc/cate01';
  static CATEGORY_LIST_ALL = SECURE_ENDPOINT + 'catevc/cate02';
  static CATEGORY_UPDATE = SECURE_ENDPOINT + 'catevc/cate03';
  static CATEGORY_DELETE = SECURE_ENDPOINT + 'catevc/cate04';

  /**
   * * LOG SERVICE 
   */
  static LOG_ADD = SECURE_ENDPOINT + 'logvc/log01';
  static LOG_LIST_ALL = SECURE_ENDPOINT + 'logvc/log02';
  static LOG_UPDATE = SECURE_ENDPOINT + 'logvc/log03';
  static LOG_DELETE = SECURE_ENDPOINT + 'logvc/log04';
  static LOG_FIND = SECURE_ENDPOINT + 'logvc/log05';
  static LOG_STATUS = SECURE_ENDPOINT + 'logvc/log06';
  static LOG_LIST_DATE = SECURE_ENDPOINT + 'logvc/log07';

  /**
   * * SYNC SERVICE 
   */
  static SYNC_ADD = SECURE_ENDPOINT + 'syncvc/sync01';
  static SYNC_LIST_ALL = SECURE_ENDPOINT + 'syncvc/sync02';
  static SYNC_UPDATE = SECURE_ENDPOINT + 'syncvc/sync03';
  static SYNC_DELETE = SECURE_ENDPOINT + 'syncvc/sync04';
  static SYNC_FIND = SECURE_ENDPOINT + 'syncvc/sync05';

  /**
   * * PARAMETER SERVICE 
   */
  static PARAMETER_ADD = SECURE_ENDPOINT + 'paravc/para01';
  static PARAMETER_LIST_ALL = SECURE_ENDPOINT + 'paravc/para02';
  static PARAMETER_UPDATE = SECURE_ENDPOINT + 'paravc/para03'; 
  static PARAMETER_DELETE = SECURE_ENDPOINT + 'paravc/para04'; 
  static REFERENCE_VALUE_DELETE = SECURE_ENDPOINT + 'paravc/para05';
  static ALIAS_VALUE_DELETE = `${SECURE_ENDPOINT}paravc/para06`;
  static REFERENCE_RESULT_DELETE = `${SECURE_ENDPOINT}paravc/para07`
  static PARAMETER_GET = `${SECURE_ENDPOINT}paravc/para08`

  /**
   * * FEDERAL ENTITY SERVICE
   */
  static FEDERAL_ENTITY_ADD = SECURE_ENDPOINT + 'fedentvc/fedent01';
  static FEDERAL_ENTITY_LIST_ALL = SECURE_ENDPOINT + 'fedentvc/fedent02';
  static FEDERAL_ENTITY_UPDATE = SECURE_ENDPOINT + 'fedentvc/fedent03';
  static FEDERAL_ENTITY_DELETE = SECURE_ENDPOINT + 'fedentvc/fedent04';

  /**
   * * MUNICIPALITY SERVICE
   */
  static MUNICIPALITY_ADD = SECURE_ENDPOINT + 'munvc/mun01';
  static MUNICIPALITY_LIST_ALL = SECURE_ENDPOINT + 'munvc/mun02';
  static MUNICIPALITY_UPDATE = SECURE_ENDPOINT + 'munvc/mun03';
  static MUNICIPALITY_DELETE = SECURE_ENDPOINT + 'munvc/mun04';

  /**
   * * COLONY SERVICE
   */
  static COLONY_ADD = SECURE_ENDPOINT + 'colvc/col01';
  static COLONY_LIST_ALL = SECURE_ENDPOINT + 'colvc/col02';
  static COLONY_UPDATE = SECURE_ENDPOINT + 'colvc/col03';
  static COLONY_DELETE = SECURE_ENDPOINT + 'colvc/col04';

  /**
   * * HUMAN RESOURCE SERVICE
   */
  static HUMAN_RESOURCE_ADD = SECURE_ENDPOINT + 'humanvc/human01';
  static HUMAN_RESOURCE_LIST_ALL = SECURE_ENDPOINT + 'humanvc/human02';
  static HUMAN_RESOURCE_UPDATE = SECURE_ENDPOINT + 'humanvc/human03';
  static HUMAN_RESOURCE_DELETE = SECURE_ENDPOINT + 'humanvc/human04';
  static HUMAN_RESOURCE_BY_STATUS = SECURE_ENDPOINT + 'humanvc/human05';
  static HUMAN_RESOURCE_BY_BRANCH_OFFICE = SECURE_ENDPOINT + 'humanvc/human06';
  static HUMAN_RESOURCE_BY_BRANCH_OFFICE_AND_TYPE = SECURE_ENDPOINT + 'humanvc/human07';
  static HUMAN_RESOURCE_RESPONSIBLE = SECURE_ENDPOINT + 'humanvc/human08';

  /**
   * * BRANCH OFFICE SERVICE
   */
  static BRANCH_OFFICE_ADD = SECURE_ENDPOINT + 'branchvc/branch01';
  static BRANCH_OFFICE_LIST_ALL = SECURE_ENDPOINT + 'branchvc/branch02';
  static BRANCH_OFFICE_UPDATE = SECURE_ENDPOINT + 'branchvc/branch03';
  static BRANCH_OFFICE_DELETE = SECURE_ENDPOINT + 'branchvc/branch04';
  static BRANCH_OFFICE_STATUS = SECURE_ENDPOINT + 'branchvc/branch05';
  static BRANCH_OFFICE_ALL_2 = SECURE_ENDPOINT + "branchvc/branch07";
  static BRANCH_OFFICE_PRINCIPAL = SECURE_ENDPOINT + 'branchvc/branch08';

  /**
   * * CONSULTING ROOM SERVICE
   */
  static CONSULTING_ROOM_ADD = SECURE_ENDPOINT + 'crvc/cr01';
  static CONSULTING_ROOM_LIST_ALL = SECURE_ENDPOINT + 'crvc/cr02';
  static CONSULTING_ROOM_UPDATE = SECURE_ENDPOINT + 'crvc/cr03';
  static CONSULTING_ROOM_DELETE = SECURE_ENDPOINT + 'crvc/cr04';
  static CONSULTING_ROOM_LIST_BY_ID = SECURE_ENDPOINT + 'crvc/cr05';
  static CONSULTING_ROOM_LIST_BY_MODALTY = SECURE_ENDPOINT + 'crvc/cr06';
  static CONSULTING_ROOM_LIST = SECURE_ENDPOINT + 'crvc/cr07';
  static CONSULTING_ROOM_STATUS = SECURE_ENDPOINT + 'crvc/cr08';


  static CONSULTING_ROOM_MODALITY_ALL = SECURE_ENDPOINT + 'crmodvc/crmod02';
  static CONSULTING_ROOM_MODALITY_ADD = SECURE_ENDPOINT + 'crmodvc/crmod01';
  static CONSULTING_ROOM_MODALITY_DELETE = SECURE_ENDPOINT + 'crmodvc/crmod04';

  /**
   * * CLINICAL EVENT SERVICE
   */
  static CLINICAL_EVENT_ADD = SECURE_ENDPOINT + 'clinevc/cline01';
  static CLINICAL_EVENT_LIST_ALL = SECURE_ENDPOINT + 'clinevc/cline02';
  static CLINICAL_EVENT_DELETE = SECURE_ENDPOINT + 'clinevc/cline03';
  static CLINICAL_EVENT_UPDATE = SECURE_ENDPOINT + 'clinevc/cline04';
  static CLINICAL_EVENT_LIST_BY_ID = SECURE_ENDPOINT + 'clinevc/cline05';
  static CLINICAL_EVENT_LIST_BY_PATIENT = SECURE_ENDPOINT + 'clinevc/cline06';

  /**
   * * MODALTY SERVICE
   */
  static MODALTY_ADD = SECURE_ENDPOINT + 'modvc/mod01';
  static MODALTY_LIST_ALL = SECURE_ENDPOINT + 'modvc/mod02';
  static MODALTY_UPDATE = SECURE_ENDPOINT + 'modvc/mod03';
  static MODALTY_DELETE = SECURE_ENDPOINT + 'modvc/mod04';
  static MODALTY_LIST_BY_SPECIALITY = SECURE_ENDPOINT + 'modvc/mod05';
  static MODALTY_LIST_BY_BRANCH_OFFICE_AND_SPECIALITY = SECURE_ENDPOINT + 'modvc/mod06';
  static MODALTY_LIST_BY_HUMAN_RESOURCE_AND_SPECIALITY = SECURE_ENDPOINT + 'modvc/mod07';
  static MODALITY_CHECK_SPECIALITY = SECURE_ENDPOINT + 'modvc/mod08';

  /**
   * * STUDY MODALTY SERVICE
   */
  static STUDY_MODALTY_ADD = SECURE_ENDPOINT + 'stumodvc/stumod01'
  static STUDY_MODALTY_LIST_ALL = SECURE_ENDPOINT + 'stumodvc/stumod02'
  static STUDY_MODALTY_UPDATE = SECURE_ENDPOINT + 'stumodvc/stumod03'
  static STUDY_MODALTY_DELETE = SECURE_ENDPOINT + 'stumodvc/stumod04'
  static STUDY_MODALTY_LIST_BY_MODALTY = SECURE_ENDPOINT + 'stumodvc/stumod05'
  static STUDY_MODALTY_LIST_BY_SPECIALITY_AND_USER = SECURE_ENDPOINT + 'stumodvc/stumod06'
  static STUDY_MODALITY_ALL_BY_MODALITY_AND_BRANCH_OFFICE = SECURE_ENDPOINT + 'stumodvc/stumod07'

  /**
   * * MEDICAL PRACTICE SERVICE
   */
  static MEDICAL_PRACTICE_ADD = SECURE_ENDPOINT + 'medpavc/medpa01';
  static MEDICAL_PRACTICE_LIST_ALL = SECURE_ENDPOINT + 'medpavc/medpa02';
  static MEDICAL_PRACTICE_UPDATE = SECURE_ENDPOINT + 'medpavc/medpa03';
  static MEDICAL_PRACTICE_DELETE = SECURE_ENDPOINT + 'medpavc/medpa04';
  static MEDICAL_PRACTICE_RESCHEDULE = SECURE_ENDPOINT + 'medpavc/medpa05';
  static MEDICAL_PRACTICE_CANCEL = SECURE_ENDPOINT + 'medpavc/medpa06';
  static MEDICAL_PRACTICE_ABSENCE = SECURE_ENDPOINT + 'medpavc/medpa07';
  static MEDICAL_PRACTICE_LIST_BY_STATUS = SECURE_ENDPOINT + 'medpavc/medpa08';
  static MEDICAL_PRACTICE_LIST_BY_ID = SECURE_ENDPOINT + 'medpavc/medpa09';
  static MEDICAL_PRACTICE_LIST_BY_APPOINMENT = SECURE_ENDPOINT + 'medpavc/medpa10';
  static MEDICAL_PRACTICE_DETAILS = SECURE_ENDPOINT + 'medpavc/medpa12';
  static MEDICAL_PRACTICE_QR_INFO = SECURE_ENDPOINT + "medpavc/medpa13";
  static MEDICAL_PRACTICE_ATTEND = SECURE_ENDPOINT + "medpavc/mc01";
  static MEDICAL_PRACTICE_BY_STATUS_AND_SPECIALITY = SECURE_ENDPOINT + "medpavc/medpa14";
  static MEDICAL_PRACTICE_DETAIL_SUMMARIZED = SECURE_ENDPOINT + "medpavc/medpa15";
  static MEDICAL_PRACTICE_CANCEL2 = SECURE_ENDPOINT + "medpavc/medpa16";
  static MEDICAL_PRACTICE_BY_DATE = SECURE_ENDPOINT + "medpavc/medpa14";
  
  /**
     * @author Fernando FH
     * @description Listado paginado historial de consulta externa.
     * @created 22/08/2022
     * */
  static MEDICAL_PRACTICE_LIST_HISTORY_PAGINATE = SECURE_ENDPOINT + "medpavc/medpa19";

  /**
   * * USER SERVICE
   */
  static USER_ADD = SECURE_ENDPOINT + 'usrvc/usr01';
  static USER_ALL = SECURE_ENDPOINT + 'usrvc/usr02';
  static USER_UPDATE = SECURE_ENDPOINT + 'usrvc/usr03';
  static USER_DELETE = SECURE_ENDPOINT + 'usrvc/usr04';
  static USER_FIND = SECURE_ENDPOINT + 'usrvc/usr05';
  static USER_RESTORE_PASSWORD = SECURE_ENDPOINT + 'usrvc/usr06';
  static USER_HISTORY = SECURE_ENDPOINT + 'usrvc/usr07';
  static USER_ALL_BRANCH_OFFICE = SECURE_ENDPOINT + 'usrvc/usr08';

  /**
   * * TYPE VITAL SIGN SERVICE
   */
  static TYPE_VITAL_SIGN_ADD = SECURE_ENDPOINT + 'vitaltypevc/vitaltype01';
  static TYPE_VITAL_SIGN_LIST_ALL = SECURE_ENDPOINT + 'vitaltypevc/vitaltype02';
  static TYPE_VITAL_SIGN_UPDATE = SECURE_ENDPOINT + 'vitaltypevc/vitaltype03';
  static TYPE_VITAL_SIGN_DELETE = SECURE_ENDPOINT + 'vitaltypevc/vitaltype04';

  /**
   * * VITAL SIGN SERVICE 
   */
  static VITAL_SIGN_ADD = SECURE_ENDPOINT + 'vitalvc/vital01';
  static VITAL_SIGN_LIST_ALL = SECURE_ENDPOINT + 'vitalvc/vital02';
  static VITAL_SIGNS_ALL_BY_PATIENT_OR_STUDY_OR_MEDICAL_PRACTICE = SECURE_ENDPOINT + 'vitalvc/vital03';
  
    /**
   * * CALCULATORS SOMATOMETRY SERVICE 
   */
    static CALCULATORS_SOMATOMETRY = OTHER_SECURE_ENDPOINT + 'eva/eva02';
    static CALCULATORS_SOMATOMETRY_SAVE = OTHER_SECURE_ENDPOINT + 'eva/eva03';
    static CALCULATORS_SOMATOMETRY_EDIT = OTHER_SECURE_ENDPOINT + 'eva/eva04';

/**
   * *COLPOSCOPY FORM SERVICE 
   */

    static GET_COLPOSCOPY_FORM_FROM_INTERPRETATION = OTHER_SECURE_ENDPOINT + 'eva/eva01';
    static EDIT_COLPOSCOPY_FORM_FROM_INTERPRETATION = OTHER_SECURE_ENDPOINT + 'eva/eva02';
    static COLPOSCOPY_FORM = OTHER_SECURE_ENDPOINT + 'eva/eva02';
    static SAVE_COLPOSCOPY_FORM = OTHER_SECURE_ENDPOINT + 'eva/eva03';
    static EDIT_COLPOSCOPY_FORM = OTHER_SECURE_ENDPOINT + 'eva/eva04';


    /**
   * *PAPANICOLAOU FORM SERVICE 
   */

    static STUDY_PAPANICOLAOU_FORM = OTHER_SECURE_ENDPOINT + 'eva/eva02';
    static STUDY_PAPANICOLAOU_TABLE = SECURE_ENDPOINT + 'lbssv/lbs01';
    static STUDY_PAPANICOLAOU_SAVE_FORM = OTHER_SECURE_ENDPOINT + 'eva/eva03';
    static STUDY_PAPANICOLAOU_SAVE_TABLE = SECURE_ENDPOINT + 'lbssv/lbs02';
    static STUDY_PAPANICOLAOU_SAVE_FILES = OTHER_SECURE_ENDPOINT + 'stu/stf01';

    static STUDY_PAPANICOLAOU_EDIT_FORM = OTHER_SECURE_ENDPOINT + 'eva/eva04';
    static STUDY_PAPANICOLAOU_EDIT_TABLE = SECURE_ENDPOINT + 'lbssv/lbs03';
    static STUDY_PAPANICOLAOU_REPORT = OTHER_SECURE_ENDPOINT + 'stu/stf02';
    static STUDY_PAPANICOLAOU_DOWNLOAD_REPORT = SECURE_ENDPOINT + 'rpsvc/rp55';
    static STUDY_PAPANICOLAOU_DOWNLOAD_EXCEL = SECURE_ENDPOINT + 'rpsvc/rp54';


  /**
   * * ANTECEDENT SERVICE
   */
  static ANTECEDENT_ADD_TEMP = SECURE_ENDPOINT + 'antvc/antm07'
  static ANTECEDENT_LIST_TEMP = SECURE_ENDPOINT + 'antvc/antm08'
  static ANTECEDENT_ADD = SECURE_ENDPOINT + 'antvc/ant01'
  static ANTECEDENT_LIST_ALL = SECURE_ENDPOINT + 'antvc/ant02'
  static ANTECEDENT_UPDATE = SECURE_ENDPOINT + 'antvc/ant03'
  static ANTECEDENT_DELETE = SECURE_ENDPOINT + 'antvc/ant04'


  /**
   * Inicio @author Fernando FH
   */

  /**
   * * INTERPRETATION 
   */
  static INTERPRETATION_PENDING_LIST_ALL_BY_MODALITY_AND_BRANCH_OFFICE = SECURE_ENDPOINT + 'intervc/inter10';
  static INTERPRETATION_SAVE = SECURE_ENDPOINT + 'intervc/inter11';
  static INTERPRETATION_HISTORY_LIST_ALL_BY_MODALITY_AND_BRANCH_OFFICE = SECURE_ENDPOINT + 'intervc/inter12';
  static INTERPRETATION_GET_BY_ID = SECURE_ENDPOINT + 'intervc/inter13';
  static INTERPRETATION_GET_ADDENDUMS = SECURE_ENDPOINT + 'intervc/inter14';
  static INTERPRETATION_HISTORY_LIST_ALL_BY_SPECIALITY = SECURE_ENDPOINT + 'intervc/inter15';
  static INTERPRETATION_GET_ONE_ADDENDUM = SECURE_ENDPOINT + "intervc/inter16";
  static INTERPRETATION_DELETE_ONE_ADDENDUM = SECURE_ENDPOINT + "intervc/inter17";
  static INTERPRETATION_UPDATE = SECURE_ENDPOINT + "intervc/inter03";
  static INTERPRETATION_COUNT_PENDING_BY_BRANCH_OFFICE = SECURE_ENDPOINT + "intervc/inter18";
  static INTERPRETATION_SAVE_FILE = SECURE_ENDPOINT + "intervc/inter19";
  static INTERPRETATION_VALIDATE = `${SECURE_ENDPOINT}intervc/intrvl01`;

  static INTERPRETATION_SAVE_FORM = OTHER_SECURE_ENDPOINT + 'eva/eva03';
  static INTERPRETATION_SAVE_FILES = OTHER_SECURE_ENDPOINT + 'clps/clps03';
  static INTERPRETATION_GET_FILES = OTHER_SECURE_ENDPOINT + 'clps/clps05';
  static INTERPRETATION_EDIT_FILES = OTHER_SECURE_ENDPOINT + 'clps/clps06';
  static INTERPRETATION_EDIT_FORM = OTHER_SECURE_ENDPOINT + 'eva/eva04';



  /**
   * * INTERPRETATION HISTORY
   */
  static INTERPRETATION_HISTORY_BY_ID_INTERPRETATION = SECURE_ENDPOINT + 'interhisvc/interhis05';


  /**
   * * BIRADS
   */
  static LIST_ALL_BIRADS = SECURE_ENDPOINT + 'biradvc/birad02';

  /**
   * * LOCATION
   */
  static CONFIGURATION_ADD_LOCATION = SECURE_ENDPOINT + 'confvc/conf10';
  static CONFIGURATION_GET_LOCATION = SECURE_ENDPOINT + 'confvc/conf11';
  static CONFIGURATION_GET_CLUES    = SECURE_ENDPOINT + 'confvc/conf20';
  static CONFIGURATION_SAVE_CLUES   = SECURE_ENDPOINT + 'confvc/conf21';

  /**
   * * TEMPLATES
   * */
  static LIST_ALL_TEMPLATE_INTERPRETATION_BY_PERSON = SECURE_ENDPOINT + 'teminvc/temin05';
  static TEMPLATE_INTERPRETATION_ADD = SECURE_ENDPOINT + 'teminvc/temin01';

  /**
   * * REPORTS PDF
   * */
  static GET_REPORT_INTERPRETATION = SECURE_ENDPOINT + 'rpsvc/rp01';
  static GET_REPORT_CONSULTATION = SECURE_ENDPOINT + 'rpsvc/rp02';
  static GET_REPORT_INTERPRETERS = SECURE_ENDPOINT + 'rpsvc/rp03';
  static REPORT_STUDIES_REPORTED_DISCARDED = SECURE_ENDPOINT + 'rpsvc/rp04';
  static GET_REPORT_PRESCRIPTION = SECURE_ENDPOINT + 'rpsvc/rp05';
  static REPORT_CLINICAL_EVENT = SECURE_ENDPOINT + "rpsvc/rp06";
  static REPORT_CLINICAL_EVENT_ZIP = SECURE_ENDPOINT + "rpsvc/rp07";
  static REPORT_PRESCRIPTION_XLSX = SECURE_ENDPOINT + 'rpsvc/rp08';
  static REPORT_STUDIES_REPORTED_DISCARDED_XLSX = SECURE_ENDPOINT + 'rpsvc/rp09';
  static REPORT_PRESCRIPTIONS_XLSX = SECURE_ENDPOINT + 'rpsvc/rp10';
  static REPORT_PRESCRIPTIONS = SECURE_ENDPOINT + 'rpsvc/rp11';
  static REPORT_BARCODE_LABORATORY = SECURE_ENDPOINT + "rpsvc/rp12";
  static GET_REPORT_INTERPRETATION_STUDY = SECURE_ENDPOINT + 'rpsvc/rp13';
  static REPORT_DENTAL_CONSULTATION = SECURE_ENDPOINT + "rpsvc/rp14";
  static REPORT_LABORATORY = SECURE_ENDPOINT + "rpsvc/rp15";
  static REPORT_DENTAL = SECURE_ENDPOINT + "rpsvc/rp16";
  static REPORT_PHARMACY_DETAILED_PDF = SECURE_ENDPOINT + 'rpsvc/rp17';
  static REPORT_PHARMACY_CONDENSED_PDF = SECURE_ENDPOINT + 'rpsvc/rp18';
  static REPORT_ORDER_STUDY = SECURE_ENDPOINT + "rpsvc/rp19";
  static REPORT_STARTING_ORDER = SECURE_ENDPOINT + "rpsvc/rp20";
  static REPORT_WAREHOUSE_ENTRY = SECURE_ENDPOINT + "rpsvc/rp21";
  static REPORT_STOCK = SECURE_ENDPOINT + "rpsvc/rp23";

  static REPORT_PATIENT = SECURE_ENDPOINT + "rpsvc/rp22";
  static REPORT_CONSULTATIONS = SECURE_ENDPOINT + "rpsvc/rp24";
  static REPORT_EXCEL_DENTAL = SECURE_ENDPOINT + "rpsvc/rp25";
  static REPORT_DOWNLOAD_LABORATORY = SECURE_ENDPOINT + "rpsvc/rp26";
  static REPORT_WAREHOUSE = SECURE_ENDPOINT + "rpsvc/rp27";
  static REPORT_DECREASE = SECURE_ENDPOINT + "rpsvc/rp28";
  static REPORT_DOWNLOAD_INTERPRETATION = SECURE_ENDPOINT + "rpsvc/rp29";
  static REPORT_DOWNLOAD_CLINICAL_HISTORY = SECURE_ENDPOINT + 'rpsvc/rp30';
  static REPORT_DOWNLOAD_ORDER_STUDY_RECEPTION = SECURE_ENDPOINT + 'rpsvc/rp31';
  static REPORT_MIESTUDIO_QR = SECURE_ENDPOINT + "rpsvc/rp39";


  /**
   * * @Mau de Pallares
   * * Speciality add on register, show on consultation
   */
   static LIST_SPECIALITY_ONREGISTER = SECURE_ENDPOINT + 'appovc/apo19'
   static REPORT_DOWNLOAD_EXCEL_PENDING_INTERPRETATION = SECURE_ENDPOINT + "rpsvc/rp33";
   static REPORT_DOWNLOAD_EXCEL_HISTORY_INTERPRETATION = SECURE_ENDPOINT + "rpsvc/rp34";


  /**
   * * IMPORT/EXPORT XLSX
   * */
  static IMPORT_MODALITY = SECURE_ENDPOINT + "imsv/im01";
  static EXPORT_MODALITY = SECURE_ENDPOINT + "imsv/im02";
  static IMPORT_ANTECEDENT = SECURE_ENDPOINT + "imsv/im03";
  static EXPORT_ANTECEDENT = SECURE_ENDPOINT + "imsv/im04";
  static IMPORT_CONSULTING_ROOM = SECURE_ENDPOINT + "imsv/im05";
  static EXPORT_CONSULTING_ROOM = SECURE_ENDPOINT + "imsv/im06";
  static IMPORT_MODALITY_STUDY = SECURE_ENDPOINT + "imsv/im07";
  static EXPORT_MODALITY_STUDY = SECURE_ENDPOINT + "imsv/im08";
  static IMPORT_ROLE = SECURE_ENDPOINT + "imsv/im09";
  static EXPORT_ROLE = SECURE_ENDPOINT + "imsv/im10";
  static IMPORT_BRANCH_OFFICE = SECURE_ENDPOINT + "imsv/im11"
  static EXPORT_BRANCH_OFFICE = SECURE_ENDPOINT + "imsv/im12"



  /**
   * * SIGN
   * */
  static SIGN_ADD = SECURE_ENDPOINT + "sivc/si01";
  static SIGN_IMAGE_BY_HUMAN_RESOURCE = SECURE_ENDPOINT + "sivc/si05";
  static SAVE_SIGN = SECURE_ENDPOINT + 'sivc/si06';
  static SIGN_SAVE_TO_USER = SECURE_ENDPOINT + "sivc/si07";


  /**
   * * DOWNLOAD ZIP
   * */
  static DOWNLOAD_IMAGES_DCM = SECURE_ENDPOINT + 'dwsv/dw01';
  static DOWNLOAD_PATIENT_FILE = SECURE_ENDPOINT + "dwsv/dw02";
  static DOWNLOAD_INTERPRETATION_FILE = SECURE_ENDPOINT + "dwsv/dw03";
  static DOWNLOAD_REPORT_PRODUCTIVITY = SECURE_ENDPOINT + "dwsv/dw04";
  static DOWNLOAD_DICOM_PDF = SECURE_ENDPOINT + "dwsv/dw05";
  static DOWNLOAD_STUDY_ZIP = SECURE_ENDPOINT + "dwsv/";
  static GENERATE_DOWNLOAD_ACCESS_STUDY = SECURE_ENDPOINT + "dwsv/dw08";

  /**
   * * REPORT BIRADS
   * */
  static SAVE_REPORT_BIRADS = SECURE_ENDPOINT + 'biradrevc/biradre01';

  /** 
   * * PERMISSION SERVICE
   */
  static PERMISSIONS_ADD = SECURE_ENDPOINT + 'permvc/perm01';
  static PERMISSIONS_LIST_ALL = SECURE_ENDPOINT + 'permvc/perm02';
  static PERMISSIONS_UPDATE = SECURE_ENDPOINT + 'permvc/perm03';
  static PERMISSIONS_DELETE = SECURE_ENDPOINT + 'permvc/perm04';

  /** 
   * * MODULE SERVICE
   */
  static MODULE_ADD = SECURE_ENDPOINT + 'mdlvc/mdl01';
  static MODULE_LIST_ALL = SECURE_ENDPOINT + 'mdlvc/mdl02';
  static MODULE_LIST_ALL_WITH_PERMISSIONS = SECURE_ENDPOINT + 'modulevc/module05';
  static MODULE_LIST_ALL_WITH_PERMISSIONS_BY_ROL = SECURE_ENDPOINT + 'modulevc/module06';
  static MODULE_UPDATE = SECURE_ENDPOINT + 'mdlvc/mdl03';
  static MODULE_DELETE = SECURE_ENDPOINT + 'mdlvc/mdl04';
  static MODULE_GET = SECURE_ENDPOINT + 'mdlvc/mdl05';
  static MODULE_LIST = SECURE_ENDPOINT + 'modulevc/module02';


  /** 
   * * STOCK SERVICE
   */
  static STOCK_ADD_ENTRY = SECURE_ENDPOINT + 'stksv/stk01';
  static STOCK_BY_BRANCH_OFFICE = SECURE_ENDPOINT + 'stksv/stk02';
  static STOCK_ADD_OUTPUT = SECURE_ENDPOINT + 'stksv/stk03';
  static STOCK_WAREHOUSE_OUTPUT_BY_BRANCH_OFFICE = SECURE_ENDPOINT + 'stksv/stk04';
  static STOCK_WAREHOUSE_OUTPUT_BY_ID = SECURE_ENDPOINT + 'stksv/stk05';
  static STOCK_BY_PRESCRIPTION_AND_BRANCH_OFFICE = SECURE_ENDPOINT + "stksv/stk06";
  static STOCK_HISTORY = SECURE_ENDPOINT + "stksv/stk07";
  static STOCK_UPDATE_QUANTITY = SECURE_ENDPOINT + "stksv/stk08";
  static STOCK_BY_ID = SECURE_ENDPOINT + "stksv/stk09";

  /** 
   * * LABORATORY SERVICE
   */
  static STUDY_LABORATORY_LIST_PARAMETERS_BY_STUDY = SECURE_ENDPOINT + 'lbssv/lbs01';
  static STUDY_LABORATORY_SAVE = SECURE_ENDPOINT + 'lbssv/lbs02';
  static STUDY_LABORATORY_UPDATE = SECURE_ENDPOINT + 'lbssv/lbs03';


  /**
   * Profile service 
   **/
  static PERSON_UPDATE_PROFILE = SECURE_ENDPOINT + "persvc/prf01";
  static USER_UPDATE_PROFILE = SECURE_ENDPOINT + 'usrvc/usf01';
  static CONTACT_INFORMATION_UPDATE_PROFILE = SECURE_ENDPOINT + 'coninfvc/coninf03';
  static ADDRESS_UPDATE_PROFILE = SECURE_ENDPOINT + 'addrvc/addr03';
  static ACADEMIC_TITLE_UPDATE_PROFILE = SECURE_ENDPOINT + 'activc/acti03';


  /**
   * Evaluation service 
   **/
  static EVALUATION_LIST_BY_TYPE = SECURE_ENDPOINT + "evlvc/evl01";
  static EVALUATION_LIST_PERSON_AND_TYPE = SECURE_ENDPOINT + "evlvc/evl02";
  static EVALUATION_SAVE = SECURE_ENDPOINT + "evlvc/evl03";
  static EVALUATION_LIST_ALL = SECURE_ENDPOINT + "evlvc/evl04";
  static EVALUATION_UPDATE = SECURE_ENDPOINT + "evlvc/evl05";
  static EVALUATION_ADD = SECURE_ENDPOINT + "evlvc/evl06";
  static EVALUATION_DELETE_ANSWARE = SECURE_ENDPOINT + "evlvc/evl07";
  static EVALUATION_DELETE_QUESTION = SECURE_ENDPOINT + "evlvc/evl08";
  static EVALUATION_DELETE_EVALUATION = SECURE_ENDPOINT + "evlvc/evl09";



  /**
   * Fin @author Fernando FH
   */

  /**
   * 
   * @author 
   * 
   **/

  /** 
   * * ROLE SERVICE
   */
  static ROLE_ADD = SECURE_ENDPOINT + 'rolevc/role01';
  static ROLE_ALL = SECURE_ENDPOINT + 'rolevc/role02';
  static ROLE_UPDATE = SECURE_ENDPOINT + 'rolevc/role03';
  static ROLE_DELETE = SECURE_ENDPOINT + 'rolevc/role04';
  static ROLE_STATUS = SECURE_ENDPOINT + 'rolevc/role05';
  static ROLE_GET = SECURE_ENDPOINT + 'rolevc/role06';

  /** 
   * * BranchOffice Modality SERVICE
   */
  static BRANCH_OFFICE_MODALITY_ADD = SECURE_ENDPOINT + 'brmvc/brm01';
  static BRANCH_OFFICE_MODALITY_LIST_ALL_BY_BRANCH_OFFICE = SECURE_ENDPOINT + 'brmvc/brm02';
  static BRANCH_OFFICE_MODALITY_UPDATE = SECURE_ENDPOINT + 'brmvc/brm03';
  static BRANCH_OFFICE_MODALITY_DELETE = SECURE_ENDPOINT + 'brmvc/brm04';
  static BRANCH_OFFICE_MODALITY_LIST_ALL_BY_BRANCH_OFFICE_ACTIVE = SECURE_ENDPOINT + 'brmvc/brm05';

  /** 
   * *Sepomex Service
   */
  static SEPOMEX_ALL_BY_CP = SECURE_ENDPOINT + 'spxvc/spx01';


  /**
   * * PRESCRIPTION SERVICE
   */
  static PRESCRIPTION_ADD = SECURE_ENDPOINT + 'prescvc/presc01'
  static PRESCRIPTION_LIST_ALL = SECURE_ENDPOINT + 'prescvc/presc02'
  static PRESCRIPTION_UPDATE = SECURE_ENDPOINT + 'prescvc/presc03'
  static PRESCRIPTION_DELETE = SECURE_ENDPOINT + 'prescvc/presc04'
  static PRESCRIPTION_LIST_ALL_BY_STATUS = SECURE_ENDPOINT + 'prescvc/presc05'
  static PRESCRIPTION_LIST_ALL_BY_STATUS_PAGED = SECURE_ENDPOINT + 'prescvc/presc06'
  static STOCK_PRESCRIPTION_SAVE = SECURE_ENDPOINT + 'prescvc/prs07';
  static STOCK_PRESCRIPTION_DELETE = SECURE_ENDPOINT + 'prescvc/prs08';

  /** 
   * * ROLE-PERMISSION SERVICE
   */
  static ROLE_PERMISSION_ADD = SECURE_ENDPOINT + 'rolepervc/roleper01';
  static ROLE_PERMISSION_LIST_ALL = SECURE_ENDPOINT + 'rolepervc/roleper02';
  static ROLE_PERMISSION_UPDATE = SECURE_ENDPOINT + 'rolepervc/roleper03';
  static ROLE_PERMISSION_DELETE = SECURE_ENDPOINT + 'rolepervc/roleper04';
  static ROLE_PERMISSION_SAVE = SECURE_ENDPOINT + 'rolepervc/roleper05';
  static ROLE_PERMISSION_DUPLICATE = SECURE_ENDPOINT + 'rolepervc/roleper06';

  /**
   * * PRODUCTS SERVICE
   */
  static PRODUCTS_ADD = SECURE_ENDPOINT + 'produvc/produ01'
  static PRODUCTS_LIST_ALL = SECURE_ENDPOINT + 'produvc/produ02'
  static PRODUCTS_UPDATE = SECURE_ENDPOINT + 'produvc/produ03'
  static PRODUCTS_DELETE = SECURE_ENDPOINT + 'produvc/produ04'
  static PRODUCTS_LIST_ALL_STOCK = SECURE_ENDPOINT + 'produvc/produ05'
  static PRODUCTS_LIST_ALL_WITH_EXISTENCE = SECURE_ENDPOINT + 'produvc/prd06'


  /**
   * * SPECIALITY SERVICE
   */
  static SPECIALITY_ADD = SECURE_ENDPOINT + 'spvc/sp01';
  static SPECIALITY_LIST_ALL = SECURE_ENDPOINT + 'spvc/sp02';
  static SPECIALITY_UPDATE = SECURE_ENDPOINT + 'spvc/sp03';
  static SPECIALITY_DELETE = SECURE_ENDPOINT + 'spvc/sp04';
  static SPECIALITY_LIST_STATUS = SECURE_ENDPOINT + 'spvc/sp06';

  /**
   * CANCELLED'
  */
  static CANCELLED_APPOINTMENT = SECURE_ENDPOINT + 'stufivc/stufi08';
  static CANCELLED_MEDICAL_PRACTICE = SECURE_ENDPOINT + 'stufivc/stufi06';
  static CANCELLED_PRESCRIPTION = SECURE_ENDPOINT + 'stufivc/stufi07';
  static CANCELLED_STUDY = SECURE_ENDPOINT + 'stufivc/stufi05';

  static UPDATE_STATUS_LIST_APPOINTMENT = SECURE_ENDPOINT + 'appovc/apo16';
  static UPDATE_STATUS_LIST_MEDICAL_PRACTICE = SECURE_ENDPOINT + 'medpavc/medpa18';
  static UPDATE_STATUS_LIST_PRESCRIPTION = SECURE_ENDPOINT + 'prescvc/presc07';
  static UPDATE_STATUS_LIST_STUDY = SECURE_ENDPOINT + 'stuvc/stu25';


  /**
   * * STUDY FINISHED SERVICE
   */
  static STUDY_FINISHED_ADD = SECURE_ENDPOINT + "stufivc/stufi01";
  static STUDY_FINISHED_ALL = SECURE_ENDPOINT + "stufivc/stufi02";
  static STUDY_FINISHED_UPDATE = SECURE_ENDPOINT + "stufivc/stufi03";
  static STUDY_FINISHED_DELETE = SECURE_ENDPOINT + "stufivc/stufi04";
  static STUDY_REPORTED_DISCARDED = SECURE_ENDPOINT + "stufivc/stufi05";


  /**
   * * PHARMACY PRESCRIPTION SERVICE
   * ! Servicio temporal
   */
  static PHARMACY_PRESCRIPTION_ADD = SECURE_ENDPOINT + 'preprovc/prepro01'
  static PHARMACY_PRESCRIPTION_LIST_ALL = SECURE_ENDPOINT + 'preprovc/prepro02'
  static PHARMACY_PRESCRIPTION_UPDATE = SECURE_ENDPOINT + 'preprovc/prepro03'
  static PHARMACY_PRESCRIPTION_DELETE = SECURE_ENDPOINT + 'preprovc/prepro04'
  static PHARMACY_PRESCRIPTION_LIST_ALL_BY_PRESCRIPTION = SECURE_ENDPOINT + 'preprovc/prepro05'
  static PHARMACY_PRESCRIPTION_DISPENSE = SECURE_ENDPOINT + 'preprovc/prepro06'
  static PHARMACY_PRESCRIPTION_UPDATE_STATUS = SECURE_ENDPOINT + 'preprovc/prepro07'

  /**
   * * BRANCH OFFICE HOURS SERVICE
   */
  static BRANCH_OFFICE_HOURS_ADD = SECURE_ENDPOINT + 'branchourvc/branchour01';
  static BRANCH_OFFICE_HOURS_ALL = SECURE_ENDPOINT + 'branchourvc/branchour02';
  static BRANCH_OFFICE_HOURS_UPDATE = SECURE_ENDPOINT + 'branchourvc/branchour03';
  static BRANCH_OFFICE_HOURS_DELETE = SECURE_ENDPOINT + 'branchourvc/branchour04';
  static BRANCH_OFFICE_HOURS_ADD_LIST = SECURE_ENDPOINT + 'branchourvc/branchour05';
  static BRANCH_OFFICE_HOURS_BY_ID = SECURE_ENDPOINT + 'branchourvc/branchour06';
  static BRANCH_OFFICE_HOURS_BY_ID_ORDER = SECURE_ENDPOINT + 'branchourvc/branchour07';

  /**
   * * HEALTH INSURANCE SERVICE
   */
  static HEALTH_INSURANCE_LIST_ALL = SECURE_ENDPOINT + 'hlnsv/hln01'

  /**
   * * PACS CONFIGURATION SERVICE
   */
  static PACS_CONFIGURATION_ADD = SECURE_ENDPOINT + 'confvc/conf01'
  static PACS_CONFIGURATION_LIST_ALL = SECURE_ENDPOINT + 'confvc/conf02'
  static PACS_CONFIGURATION_UPDATE = SECURE_ENDPOINT + 'confvc/conf03'
  static PACS_CONFIGURATION_DELETE = SECURE_ENDPOINT + 'confvc/conf04'
  static PACS_CONFIGURATION_LIST_BY_BRANCHOFFICE = SECURE_ENDPOINT + 'confvc/conf05'
  static CONFIGURATION_ADD_ADDENDUMS = SECURE_ENDPOINT + "confvc/conf06";
  static CONFIGURATION_ALL_ADDENDUMS = SECURE_ENDPOINT + "confvc/conf07";
  static CONFIGURATION_ALL_CONFIG = SECURE_ENDPOINT + "confvc/conf08";
  static CONFIGURATION_ADDENDUMS_BY_BRANCH = SECURE_ENDPOINT + "confvc/conf09";
  static CONFIGURATION_GET_LICENSE = SECURE_ENDPOINT + "confvc/conf13";
  static CONFIGURATION_ADD_LICENSE = SECURE_ENDPOINT + "confvc/conf12";
  static CONFIGURATION_GET_REPORT_APP = SECURE_ENDPOINT + "confvc/conf14";
  static CONFIGURATION_ADD_REPORT_APP = SECURE_ENDPOINT + "confvc/conf15";
  static CONFIGURATION_GET_CONFIG_RECEPTION = SECURE_ENDPOINT + "confvc/conf16";
  static CONFIGURATION_ADD_CONFIG_RECEPTION = SECURE_ENDPOINT + "confvc/conf17";


  /**
   * * PATIENT FILE SERVICE
   */
  static PATIENT_FILE_ADD = SECURE_ENDPOINT + "pafvc/paf01";
  static PATIENT_FILE_FIND = SECURE_ENDPOINT + "pafvc/paf02";
  static PATIENT_FILE_FIND_BY_PATIENT = SECURE_ENDPOINT + "pafvc/paf03";
  static PATIENT_FILE_FIND_ONE_BY_PATIENT = SECURE_ENDPOINT + "pafvc/paf04";
  static PATIENT_FILE_DELETE_ONE_BY_PATIENT = SECURE_ENDPOINT + "pafvc/paf05";
  static PATIENT_SCANNED_ADD = SECURE_ENDPOINT + "pafvc/paf06";
  static PATIENT_FILE_ADD_INTERPRETATION = SECURE_ENDPOINT + "pafvc/paf07";

  /**
   * * CIE10 SERVICE
   */
  static CIE_ADD = SECURE_ENDPOINT + 'cievc/cie01'
  static CIE_LIST_ALL = SECURE_ENDPOINT + 'cievc/cie02'
  static CIE_UPDATE = SECURE_ENDPOINT + 'cievc/cie03'
  static CIE_DELETE = SECURE_ENDPOINT + 'cievc/cie04'
  static CIE_LIST_BY_KEY = SECURE_ENDPOINT + 'cievc/cie05'
  static CIE_LIST_BY_NAME = SECURE_ENDPOINT + 'cievc/cie06'

  /**
   * Personal Type
   */

  static PERSONAL_TYPE_ADD = SECURE_ENDPOINT + "petvc/pet01";
  static PERSONAL_TYPE_LIST = SECURE_ENDPOINT + "petvc/pet02";
  static PERSONAL_TYPE_FIND = SECURE_ENDPOINT + "petvc/pet03";
  static PERSONAL_TYPE_UPDATE = SECURE_ENDPOINT + "petvc/pet04";

  static BRANCH_OFFICE_PERSON_ADD = SECURE_ENDPOINT + "bopvc/bop01";
  static BRANCH_OFFICE_PERSON_FIND = SECURE_ENDPOINT + "bopvc/bop02";
  static BRANCH_OFFICE_PERSON_FIND2 = SECURE_ENDPOINT + "bopvc/bop03";


  /**
   * * PROCEDURE SERVICE
   */
  static PROCEDURE_ADD = SECURE_ENDPOINT + 'procvc/proc01'
  static PROCEDURE_LIST_ALL = SECURE_ENDPOINT + 'procvc/proc02'
  static PROCEDURE_LIST_ALL_BY_TYPE = SECURE_ENDPOINT + 'procvc/proc03'
  static PROCEDURE_UPDATE = SECURE_ENDPOINT + 'procvc/proc04'
  static ATTENTION_TYPE_LIST = SECURE_ENDPOINT + 'procvc/proc05'

  /**
   * * PROCEDURE APPLICATION
   */
  static PROCEDURE_APPLICATION_ADD = SECURE_ENDPOINT + 'papvc/pap01'
  static PROCEDURE_APPLICATION_LIST_BY_MEDICAL = SECURE_ENDPOINT + 'papvc/pap02'
  static PROCEDURE_APPLICATION_UPDATE = SECURE_ENDPOINT + 'papvc/pap04'

  /**
   * * PROCEDURE APPLICATION
   * @author Teresa Ocampo Roman
   */
  static LOGO_TEMPLATE_ADD = SECURE_ENDPOINT + 'ltevc/lte01';
  static LOGO_TEMPLATE_FIND = SECURE_ENDPOINT + 'ltevc/lte02';
  static TEMPLATE_HTML_LIST = SECURE_ENDPOINT + 'ltevc/lte03';
  static LOGO_ADD = SECURE_ENDPOINT + 'ltevc/lte04';
  static LOGO_LIST = SECURE_ENDPOINT + "ltevc/lte05";
  static LOGO_DELETE=SECURE_ENDPOINT + "ltevc/lte06";
  static LOGO_BY_TEMPLATES=SECURE_ENDPOINT + "ltevc/lte07";

  /**
   * * LOCATION

   */
  static LOCATION_ADD = SECURE_ENDPOINT + 'locvc/loc01';
  static LOCATION_ALL = SECURE_ENDPOINT + 'locvc/loc02';
  static LOCATION_UPDATE = SECURE_ENDPOINT + 'locvc/loc03';
  static LOCATION_BY_ID = SECURE_ENDPOINT + 'locvc/loc04';
  static LOCATION_BY_CLUES = SECURE_ENDPOINT + 'locvc/loc05';
  
  /*********************************************************************************************** */
  /**
   * @Mau de Pallares
   * @Psychology PDF
   */
  static PSYCHOLOGY_PDF = SECURE_ENDPOINT + "rpsvc/rpt32";

  /**
   * 
   * @Optometry
   */
  static OPTOMETRY_PDF = SECURE_ENDPOINT + "rpsvc/rpt35";
  static OPTOMETRY_EXCELPRODUCTIVITY = SECURE_ENDPOINT + "rpsvc/rp36";

  /**
   * 
   * @Audiometry
   */
  static AUDIOMETRY_PDF = SECURE_ENDPOINT + "rpsvc/rpt38";
  static AUDIOMETRY_EXCELPRODUCTIVITY = SECURE_ENDPOINT + "rpsvc/rp37";

  static COLPOSCOPY_PDF =  `${SECURE_ENDPOINT}rpsvc/rpt39`;

  static TELEMEDICINE_PDF =  `${SECURE_ENDPOINT}rpsvc/rp53`;


}